/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import styled from 'styled-components';

import {baseBlue} from '../../../../../constants/colors';

export const dialogWidth = 500
export const dialogHeight = 420

export const fieldWidth = 300
export const fieldHeight = 45

export interface User {
  id: string
  firstName: string
  lastName: string
  email: string
  loginCount: string
  loginTs: number
  permissions: UserPermissions
  userStatus: string
}

export interface UserPermissions {
  admin: string
  scenarioAnalysisModels?: string
  objectDefinitionDatabase?: string
  radarDatabase?: string
  cameraDatabase?: string
  vehicleProgram?: string
  coverageRequirements?: string
  date: string
}

export interface IDialogProps {
  userData: User[]
}

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  marginBottom: 10,
  height: '100%',
})

export const Header = styled.div({
  display: 'flex',
  backgroundColor: baseBlue
})

export const LoaderWrapper = styled.div({
  display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'
})